var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdleDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 15.8337C5.15858 15.8337 3.98819 15.8337 3.14745 15.2719C2.78348 15.0287 2.47098 14.7162 2.22778 14.3522C1.66602 13.5115 1.66602 12.3411 1.66602 10.0003C1.66602 7.65956 1.66602 6.48917 2.22778 5.64843C2.47098 5.28446 2.78348 4.97196 3.14745 4.72876C3.98819 4.16699 5.15858 4.16699 7.49935 4.16699L12.4993 4.16699C14.8401 4.16699 16.0105 4.16699 16.8513 4.72876C17.2152 4.97196 17.5277 5.28446 17.7709 5.64842C18.3327 6.48917 18.3327 7.65955 18.3327 10.0003C18.3327 12.3411 18.3327 13.5115 17.7709 14.3522C17.5277 14.7162 17.2152 15.0287 16.8513 15.2719C16.0105 15.8337 14.8401 15.8337 12.4993 15.8337H7.49935Z",
    stroke: "#DEDEDE",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5C11.3807 7.5 12.5 8.61929 12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5Z",
    stroke: "#DEDEDE",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58398 12.5L4.58398 7.5",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.416 12.5L15.416 7.5",
    stroke: "#DEDEDE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdleDark);
export default __webpack_public_path__ + "static/media/Idle Dark.e1de4fdb5da3488237ebba396d9becaf.svg";
export { ForwardRef as ReactComponent };